module.exports = __webpack_public_path__ + "static/media/WhatsApp Image 2026-08-05 at 10.38.52 (1).c30a63b2.jpeg";